import { createContext } from 'react';
import { env } from '@repo/env';
export var PromotionVariantContext = createContext({
    pragmaPromotionVariant: env.VITE_PRAGMA_PROMOTION_VARIANT,
    setPragmaPromotionVariant: function () { return undefined; },
});
